<template>
  <sidenav :orientation="orientation" :class="curClasses" :showDropdownOnHover="true">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <span class="app-brand-logo demo bg-info">
        <img :src="`${publicUrl}img/logos/logo.png`" width="35" alt="">
      </span>
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2" target="_blank">مستشفى الطارق</router-link>
      <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <!-- Dashboards -->
      <sidenav-router-link icon="ion ion-md-speedometer" to="/dashboard" :exact="true">لوحة التحكم</sidenav-router-link>

      <!-- news -->
      <sidenav-router-link icon="fa fa-newspaper" to="/posts" :exact="true">الاخبار و المقالات</sidenav-router-link>

      <!-- Roles and Permissions -->
      <!-- <sidenav-router-link icon="lnr lnr-lock" to="/accounts" :exact="true">الصلاحيات</sidenav-router-link> -->

      <!-- Employees -->
      <!-- <sidenav-router-link icon="lnr lnr-users" to="/accounts" :exact="true">المستخدمين</sidenav-router-link> -->

      <!-- Doctors -->
      <sidenav-router-link icon="fa fa-user-md" to="/doctors" :exact="true">الاطباء</sidenav-router-link>

      <!-- Patients -->
      <!-- <sidenav-router-link icon="fa fa-user-injured" to="/accounts" :exact="true">المرضى</sidenav-router-link> -->

      <!-- news -->
      <sidenav-router-link icon="fa fa-hospital" to="/departments" :exact="true">الاقسام</sidenav-router-link>

      <!-- clinics -->
      <sidenav-menu  icon="fa fa-calendar" :active="isMenuActive('/layouts')" :open="isMenuOpen('/layouts')">
      <template slot="link-text">مواعيد العيادات التخصصية</template>
        <sidenav-router-link icon="lnr lnr-sun" to="/ap/timetables/morning" :exact="true">صباحا</sidenav-router-link>
        <sidenav-router-link icon="lnr lnr-moon" to="/ap/timetables/evening" :exact="true">مساءً</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu  icon="fas fa-cog" :active="isMenuActive('/layouts')" :open="isMenuOpen('/layouts')">
      <template slot="link-text">الإعدادات</template>
        <!-- <sidenav-router-link icon="ion ion-md-map" to="/locations" :exact="true">Locations</sidenav-router-link> -->
        <!-- <sidenav-router-link icon="lnr lnr-location" to="/ports" :exact="true">Ports</sidenav-router-link> -->
        <!-- <sidenav-router-link icon="ion ion-md-boat" to="/shippingCompanies" :exact="true">Shipping Companies</sidenav-router-link> -->
      </sidenav-menu>

    </div>
  </sidenav>
</template>

<script>
// import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
import { Sidenav, SidenavRouterLink, SidenavMenu } from '@/vendor/libs/sidenav'
export default {
  name: 'app-layout-sidenav',
  components: {
    Sidenav,
    // SidenavLink,
    SidenavRouterLink,
    SidenavMenu
    // SidenavHeader,
    // SidenavBlock,
    // SidenavDivider
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
